import { configureStore } from "@reduxjs/toolkit";
import profileReducer from "./profileSlice";
import matchesReducer from "./matchesSlice";
import membershipReducer from "./membershipSlice";
import shortlistReducer from './shortlistSlice';
import activityReducer from "./activitySlice";
import requestsReducer from "./requestsSlice";
import chatListReducer from "./chatListSlice";
import photoRequestReducer from "./photoRequestSlice";
import myProfileReducer from "./myProfileSlice";

const store = configureStore({
  reducer: {
    profile: profileReducer,
    matches: matchesReducer,
    membership: membershipReducer,
    activity: activityReducer,
    shortlist: shortlistReducer,
    requests: requestsReducer,
    photoRequest: photoRequestReducer,
    myProfile: myProfileReducer,
    chatList: chatListReducer,
  },
});

export default store;
